import { slideUp } from "es6-slide-up-down"
import { toggleHeight } from "./helpers"

const backAPageOnClick = (target) => {
  if (target) {
    target.addEventListener('click', (ev) => {
      ev.preventDefault()
      window.history.back()
    })
  } else {
    console.warn('Back A Page On Click: No target given')
  }
}

const closeMenuOnClick = (target) => {
  if (target) {
    let bodyEl = document.querySelector('body')
    target.addEventListener('click', (ev) => {
      bodyEl.style.overflow = 'unset'
      bodyEl.style.maxHeight = ''

      document.querySelector('.js-menu').classList.remove('is-open')
      document.querySelector('.js-header').style.display = 'flex'
    })
  } else {
    console.warn('Close Menu On Click: No target given')
  }
}

const toggleNavOnClick = (target, is1532 = false) => {
  if (target) {
    target.addEventListener('click', (ev) => {
      let bodyEl = document.querySelector('body')
      bodyEl.style.overflow = 'hidden'
      bodyEl.style.maxHeight = '100vh'

      let jsMenu = document.querySelector('.js-menu')
      jsMenu.classList.toggle('is-open')

      let jsHeader = document.querySelector('.js-header')
      if (is1532) {
        jsHeader.classList.toggle('is-open')
        target.classList.toggle('close-menu')
      } else {
        jsHeader.style.display = 'none'
      }
    })
  } else {
    console.warn('Toggle Nav On Click: No target given')
  }
}

const toggleScrollNav = (target) => {
  if (target) {
    if (target.scrollWidth > target.outerWidth) {
      document.querySelector('.js-nav-scroll').classList.add('is-visible')
    }
  } else {
    console.warn('Toggle Scroll Nav: No target given')
  }
}

const navItemOnMouseEnter = (target) => {
  if (target) {
    target.addEventListener('mouseenter', (ev) => {
      let currentChild = document.querySelector('.js-nav-item-child.is-active')
      if (currentChild) currentChild.classList.remove('is-active');

      let newChild = document.getElementById(`${target.dataset.target.replace('#', '')}`)
      if (newChild) newChild.classList.add('is-active')

      let currentParent = document.querySelector('.is-showing-child')
      if (currentParent) currentParent.classList.remove('is-showing-child')

      target.classList.add('is-showing-child')
    })
  } else {
    console.warn('Nav Item On Hover: No target given')
  }
}

const newsNavOnClick = (target) => {
  if (target) {
    target.addEventListener('click', (ev) => {
      toggleHeight(target, 'is-open', document.querySelector('.js-news-column'))
    })
  } else {
    console.warn('News Nav On Click: No target given')
  }
}

const subNavOnClick = (target) => {
  if (target) {
    target.addEventListener('click', (ev) => {
      let subNavEl = target.parentElement.querySelector('.js-sub-nav')

      toggleHeight(target, 'menu__navigation-list-item-button--open', subNavEl, 'menu__navigation-list--mobile-hidden')
    })
  } else {
    console.warn('Sub Nav On Click: No target give')
  }
}

/**
 * Initialise navigation functionality
 */
const initNav = (is1532 = false) => {
  const subNavEls = document.querySelectorAll('.js-sub-nav-toggle')

  if (window.outerWidth >= 600) {
    // Desktop navigation
    const navItemEls = document.querySelectorAll('.js-nav-item')
    if (navItemEls) {
      Array.from(navItemEls, target => navItemOnMouseEnter(target))
    }
  } else {
    // Mobile/Tablet navigation
    if (subNavEls) {
      Array.from(subNavEls, target => subNavOnClick(target))
    }
  }
  
  window.addEventListener('resize', (ev) => {
    if (window.outerWidth > 600 && subNavEls) {
      Array.from(subNavEls, target => {
        target.classList.remove('menu__navigation-list-item-button--open')
      })

      Array.from(document.querySelectorAll('.js-sub-nav'), target => {
        target.classList.add('menu__navigation-list--mobile-hidden')
        slideUp(target)
      })
    }
  })

  const backAPageEls = document.querySelectorAll('.js-back-a-page')
  if (backAPageEls) {
    Array.from(backAPageEls, target => backAPageOnClick(target))
  }

  const closeMenuEls = document.querySelectorAll('.js-close-menu')
  if (closeMenuEls) {
    Array.from(closeMenuEls, target => closeMenuOnClick(target))
  }

  const newsNavEls = document.querySelectorAll('.js-news-nav')
  if (newsNavEls) {
    Array.from(newsNavEls, target => newsNavOnClick(target))
  }

  const scrollNavEls = document.querySelectorAll('.js-nav-scroll-items')
  if (scrollNavEls) {
    Array.from(scrollNavEls, target => toggleScrollNav(target))
  }

  const toggleNavEls = document.querySelectorAll('.js-toggle-nav')
  if (toggleNavEls) {
    Array.from(toggleNavEls, target => toggleNavOnClick(target, is1532))
  }
}

export { initNav }